import httpClient from './httpClient';

const base = '/api/registro-horas';

export const listarRegistroHoras = (mes, anio) =>
  httpClient.get(`${base}?mes=${mes}&anio=${anio}`);

export const calcularHorasAcademico = (empleado_id, mes, anio) =>
  httpClient.get(`${base}/calcular?empleado_id=${empleado_id}&mes=${mes}&anio=${anio}`);

export const crearRegistroHoras = (data) =>
  httpClient.post(base, data);

export const actualizarRegistroHoras = (id, data) =>
  httpClient.put(`${base}/${id}`, data);

export const cerrarRegistroHoras = (id) =>
  httpClient.put(`${base}/${id}/cerrar`);

export const reabrirRegistroHoras = (id) =>
  httpClient.put(`${base}/${id}/reabrir`);
